const {
  Default: _, match,
} = require('@nike/rcf-fp');

const {
  APSoutheast1Countries, EUWest1Countries, SAEast1Countries, USEast1Countries, CNNorthwest1Countries,
} = require('./static/scs-region-mappings');

const countryToRegion = (country) => match(country)(
  [() => APSoutheast1Countries.has(country), 'ap-southeast-1'],
  [() => CNNorthwest1Countries.has(country), 'cn-northwest-1'],
  [() => EUWest1Countries.has(country), 'eu-west-1'],
  [() => SAEast1Countries.has(country), 'sa-east-1'],
  [() => USEast1Countries.has(country), 'us-east-1'],
  [_, 'us-east-1'],
);

const isEMEA = (country) => EUWest1Countries.has(country);

module.exports = { countryToRegion, isEMEA };
